import React, {
  useState,
  Suspense,
  useEffect
} from "react";

import {
  renderRoutes
} from "react-router-config";

import {
  ProgressBar
} from "react-bootstrap";

import PropTypes from "prop-types";

import {
  NavBar,
  TopBar
} from "components";

import {
  isAuthenticated,
  PAGE_KEY
} from "store/auth";

import useRouter from "util/useRouter";

import "../styles.css";

const root = {
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden"
};

const container = {
  background: "#F8F8F9",
  display: "flex",
  flex: "1 1 auto",
  overflow: "hidden"
};

const content = {
  overflowY: "auto",
  flex: "1 1 auto",
  overflowX: "hidden"
};

const topBar = {
  zIndex: 2,
  position: "relative"
};

const Private = props => {
  const { route } = props;

  const { history } = useRouter();

  const [viewMenu, setViewMenu] =
    useState(false);

  const [width, setWidth] =
    useState(window.innerWidth);

  const [hidden, setHidden] =
    useState(false);

  const handleHidden = () => {
    setHidden(
      width < 768 &&
      !viewMenu
    );
  };

  const toggleMenu = () => {
    setViewMenu(currentValue => !currentValue);
  };

  useEffect(() => {
    const handleResize = () => {
      setWidth(
        window.innerWidth
      );
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  useEffect(() => {
    handleHidden();
  }, [width, viewMenu]);

  /*
   * Validação de login.
   *
   * Todas as páginas que utilizam este layout
   * precisam de um usuário autenticado.
   */
  if (!isAuthenticated()) {
    history.push(
      "/auth/login"
    );

    return null;
  }

  return (
    <div style={root}>

      <div style={container}>

        <div
          className={
            `navBar ${hidden ? "hidden" : ""}`
          }
        >

          <NavBar />

        </div>

        <main
          style={content}
          className="Content"
        >

          <div
            style={topBar}
            className="Topbar"
          >

            <TopBar
              toggleMenu={toggleMenu}
              title={
                localStorage.getItem(
                  PAGE_KEY
                )
              }
            />

          </div>

          <div className="Content_Item">

            <Suspense
              fallback={
                <ProgressBar striped />
              }
            >

              {renderRoutes(
                route.routes
              )}

            </Suspense>

          </div>

        </main>

      </div>

    </div>
  );
};

Private.propTypes = {
  route: PropTypes.object
};

export default Private;